import React from 'react'

import TieredRegSubscriptionCenter from './tier-subscription-center'

const MySubscription: React.FC = () => (
  <>
    <TieredRegSubscriptionCenter />
  </>
)

export default MySubscription
